(function(){
  'use strict';
  angular.module("irricrops")
    .directive('cuartelCrud', [ '$timeout', function($timeout) {
      return {
        restrict     : 'E',
        replace      : true,
        templateUrl  : 'shared/cuartelesCrud/cuartelesCrud.tmpl.html',
        controller   : ["$scope", "$mdDialog", function($scope, $mdDialog){


          var cuartelCrudDialogController = ["$scope",function($scope){

          var vm = this;

            vm.cuarteles =[
              {
                id:1,
                nombre: "cuartel test 1"
              },
              {
                id:2,
                nombre: "cuartel test 2"
              },
              {
                id:3,
                nombre: "cuartel test 3"
              },
              {
                id:4,
                nombre: "cuartel test 4"
              },
            ];

            vm.cuartelEdit = null;

            vm.selectCuartel = function(cuartel){
              vm.cuartelSelected = cuartel;
              vm.cuartelEdit = _.cloneDeep(cuartel);
            }
            vm.selectCuartel(vm.cuarteles[0]);




            $scope.hide = function() {
              $mdDialog.hide();
            };
            $scope.cancel = function() {
              $mdDialog.cancel();
            };
            $scope.answer = function(answer) {
              $mdDialog.hide(answer);
            };
          }];



          $scope.showDialog = function(ev) {
            $mdDialog.show({
              controllerAs        : "d",
              controller          : cuartelCrudDialogController,
              templateUrl         : 'cuartelCrudDialog.tmpl.html',
              parent              : angular.element(document.body),
              targetEvent         : ev,
              clickOutsideToClose : true,
            })
              .then(function(answer) {
                $scope.status = 'You said the information was "' + answer + '".';
              }, function() {
                $scope.status = 'You cancelled the dialog.';
              });
          };
        }]



      };
    }]);
})();
